export default __webpack_public_path__ + "static/media/blueslider2.3d52fb99.png";